<template>
  <v-app id="onKlnt">

    <defNavBar title="Ares - Guest" :actions="klnt.action_items" accolist home :notts="klnt.nott_aant" @actionClick="actionClick" />
    <nott ref="nott"></nott>
    <mergeKlnt ref="mergeKlnt"></mergeKlnt>

    <v-main>

      <v-container fluid>
        <v-row>

          <v-col cols="12" lg="6" class="px-1"> <!-- Links -->
            <v-container>
              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                  <v-form ref="klntCard1" v-model="klntCard1Valid">
                  <v-card-title>
                    {{ klnt.klnt_code }}
                        <v-spacer></v-spacer>
                        <btn_audit table="klnt" :encrid="klnt.klnt_encrid" :size=30 tooltip="audit of guest"/>

                  </v-card-title>

                  <v-row no-gutters>
                    <v-col cols="7" class="mx-1">
                      <v-text-field v-model="klnt.klnt_naam" label="Last name"></v-text-field>
                    </v-col>
                    <v-col cols="4" class="mx-1">
                      <v-text-field v-model="klnt.klnt_voornaam" label="First name"></v-text-field>
                    </v-col>
                    <!-- <v-col cols="2" class="mx-1">
                        <v-select v-model="klnt.aanh_code" :items="aanh_nrKeuzes" item-value="aanh_nr" item-text="aanhtaal_oms" label="Title"></v-select>
                    </v-col>  -->
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="5" class="mx-1">
                      <v-text-field v-model="klnt.klnt_bedrijfsnaam" label="Company name"></v-text-field>
                    </v-col>
                    <v-col cols="2">
                      <date_picker label="Date of birth"
                                   :date="dateOfBirth"
                                   field="dateOfBirth"
                                   icon="mdi-calendar-month-outline"
                                   :manual="true"
                                   placeholder="DD-MM-YYYY"
                                   :isDense="false"
                                   @updateData="updateData"/>
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="12" class="mx-1">
                      <v-text-field v-model="klnt.klnt_adres" label="Address"></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="2" class="mx-1">
                      <v-text-field v-model="klnt.klnt_postcode" label="Postal code "></v-text-field>
                    </v-col>
                    <v-col cols="5" class="mx-1">
                      <v-text-field v-model="klnt.klnt_plaats" label="City"></v-text-field>
                    </v-col>
                    <v-col cols="3" class="mx-1">
                        <v-select v-model="klnt.land_code" :items="land_nrKeuzes" item-value="land_nr" item-text="landtaal_oms" label="Country"></v-select>
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="11" class="px-1">
                      <v-text-field v-model="klnt.klnt_email" label="Email"  dense></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col cols="11" class="px-1">
                      <v-text-field v-model="klnt.klnt_email_extra" label="Email extra addresses"  dense></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3" class="px-1">
                      <v-text-field v-model="klnt.klnt_tel1_vcs" label="Tel 1 Number"></v-text-field>
                    </v-col>
                    <v-col cols="2" class="px-1">
                      <v-text-field v-model="klnt.klnt_tel1_type" label="Tel 1 Type"></v-text-field>
                    </v-col>
                     <v-col cols="2" class="px-1">
                       <v-checkbox v-model="klnt.klnt_tel1_numverify_approved" label="Numverify Approved" readonly></v-checkbox>
                     </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3" class="px-1">
                      <v-text-field v-model="klnt.klnt_tel2_vcs" label="Tel 2 Number"></v-text-field>
                    </v-col>
                    <v-col cols="2" class="px-1">
                      <v-text-field v-model="klnt.klnt_tel2_type" label="Tel 2 Type"></v-text-field>
                    </v-col>
                     <v-col cols="2" class="px-1">
                       <v-checkbox v-model="klnt.klnt_tel2_numverify_approved" label="Numverify Approved" readonly></v-checkbox>
                     </v-col>
                  </v-row>

                  <v-row no-gutters>
                    <v-col cols="3" class="mx-1">
                        <v-select v-model="klnt.taal_code" :items="taal_nrKeuzes" item-value="taal_nr" item-text="taaltaal_oms" label="Language"></v-select>
                    </v-col>

                    <v-col cols="4" class="px-1">
                      <v-text-field v-model="klnt.klnt_iban" label="IBAN" :disabled="!klnt.update_klnt_iban"></v-text-field>
                    </v-col>

                    <v-col cols="4" class="px-1">
                      <v-text-field v-model="klnt.klnt_btw_num" label="VAT number"></v-text-field>
                    </v-col>


                  </v-row>


                  <v-row no-gutters>
                    <v-col cols="2" class="mx-1">
                       <v-checkbox v-model="klnt.klnt_newsletter" label="Newsletter"></v-checkbox>
                    </v-col>

                    <v-col cols="2" class="px-1">
                      <v-text-field v-if="klnt.klnt_inschrijf_dt > ''" v-model="klnt.klnt_inschrijf_dt" label="Opt-IN" readonly></v-text-field>
                    </v-col>

                    <v-col cols="2" class="px-1">
                      <v-text-field v-if="klnt.klnt_uitschrijf_dt > ''" v-model="klnt.klnt_uitschrijf_dt" label="Opt-OUT" readonly></v-text-field>
                    </v-col>


                    <v-col cols="2" class="mx-1">
                       <v-checkbox v-model="klnt.klnt_paper_mail" label="Paper mail"></v-checkbox>
                    </v-col>

                  </v-row>


                  <v-row no-gutters>
                    <v-col cols="1" class="px-1">
                    <v-btn class="primary ma-2" :disabled="!klntCard1Valid" x-small @click="saveKlntCard1">Save</v-btn>
                    </v-col>
                  </v-row>

                  </v-form>
                  </v-card>
                </v-col>
              </v-row>

            </v-container>

          </v-col>


          <v-col cols="12" lg="6" class="px-1"> <!-- Rechts -->
            <v-container>


             <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                    <v-form ref="klntCard2">

                      <v-card-title>Points<v-spacer></v-spacer>
                        <btn_audit table="klpt" :encrid="klnt.klnt_encrid" :size=30 tooltip="audit of guest points"/>
                        <v-btn v-if="klnt.addKlptButton == true" class="primary ma-2" x-small @click="addKlpt(klnt.klnt_encrid)">Add</v-btn>
                      </v-card-title>

                      <v-row no-gutters>
                        <v-col cols="12" class="px-1">
                         <v-data-table class="elevation-1"
                              dense
                              :items="klnt.klpt"
                              :disable-pagination=true
                              :headers="klptHeaders"
                              hide-default-footer>
                           <template v-slot:item="klpt">
                            <tr v-if="klpt.item.klpt_class==='line'">
                              <td class="line">{{klpt.item.klpt_dt}} </td>
                              <td class="line">{{klpt.item.klpt_oms}} </td>
                              <td class="line">{{klpt.item.klpt_detail}} </td>
                              <td class="line">{{klpt.item.huov_code}} </td>
                              <td class="line alnright">{{klpt.item.klpt_punten}}</td>
                              <td></td>
                             </tr>
                             <tr v-if="klpt.item.klpt_class==='total'">
                              <td class="total">{{klpt.item.klpt_dt}} </td>
                              <td class="total">{{klpt.item.klpt_oms}} </td>
                              <td class="line">{{klpt.item.klpt_detail}} </td>
                              <td class="total">{{klpt.item.huov_code}} </td>
                              <td class="total alnright">{{klpt.item.klpt_punten}}</td>
                             </tr>
                           </template>
                         </v-data-table>
                        </v-col>
                      </v-row>


                    </v-form>
                   <addKlpt ref="addKlpt"></addKlpt>
                  </v-card>
                </v-col>
              </v-row>


              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                    <v-form ref="klntCard3">

                      <v-card-title>Credits<v-spacer></v-spacer>
                          <btn_audit table="kltg" :encrid="klnt.klnt_encrid" :size=30 tooltip="audit of guest credits"/>
                        <v-btn v-if="klnt.addKltgButton == true" class="primary ma-2" x-small @click="addKltg(klnt.klnt_encrid)">Add</v-btn>
                      </v-card-title>
                      <div v-if="klnt.nonsepa_text!==''" class="ml-4 mb-1" style="font-weight: bold; color: orange;">{{ klnt.nonsepa_text }}</div>
                      <v-row no-gutters>
                        <v-col cols="12" class="px-1">
                         <v-data-table class="elevation-1"
                              dense
                              :items="klnt.kltg"
                              :disable-pagination=true
                              :headers="kltgHeaders"
                              hide-default-footer>
                           <template v-slot:item="kltg">
                             <tr v-if="kltg.item.kltg_class==='line'">
                              <td class="line">{{ kltg.item.kltg_dt }}</td>
                              <td class="line">{{ kltg.item.kltg_oms2 }} <span @click="$router.open('/huov/onHuov/' + kltg.item.huov_encrid)"><a>{{ kltg.item.huov_code }}</a></span><span>{{ kltg.item.kltg_oms3 }}</span></td>
                              <td class="line alnright">{{ kltg.item.kltg_bedrag }}</td>
                              <td></td>
                             </tr>
                             <tr v-if="kltg.item.kltg_class==='total'">
                              <td class="total">{{ kltg.item.kltg_dt }}</td>
                              <td class="total">{{ kltg.item.kltg_oms }}</td>
                              <td class="total alnright">{{ kltg.item.kltg_bedrag }}</td>
                             </tr>
                           </template>
                         </v-data-table>
                        </v-col>
                      </v-row>

                   </v-form>
                   <addKltg ref="addKltg"></addKltg>
                  </v-card>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="px-1">
                  <klnt_hokl :klnt_encrid="klnt_encrid"/>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" class="px-1">
                  <v-card>
                    <v-form ref="klntCard4">

                      <v-card-title>MyBooking<v-spacer></v-spacer>
                      </v-card-title>

                      <v-row no-gutters>

                        <v-col cols="3" class="ml-4">
                          <v-text-field v-model="klnt.klnt_login_dt" label="Last Login" readonly></v-text-field>
                        </v-col>
                      </v-row>

                      <div style="display: flex; flex-direction: row; align-items:start; margin-left: 16px; margin-bottom: 16px;">
                        <v-btn class="primary mr-2" x-small @click="loginMeDev2(klnt.klnt_encrid,2)">
                          Login as Guest
                        </v-btn>
                      </div>
                      <div v-if="klnt.show_no_login_link" style="display: flex; flex-direction: row; gap: 10px; align-items: start; margin-top: 10px; margin-left: 16px; margin-bottom: 16px;">
                        <v-btn class="primary mt-1" x-small :disabled="accesslinksent" @click="sendUncheckedAccessLink(klnt.klnt_encrid)">
                          No-login access link <v-icon small v-if="accesslinksent">mdi-check</v-icon>
                        </v-btn>
                        <div>
                          Send a direct access link to {{ klnt.klnt_email }} (validity: 15 mins)
                        </div>
                      </div>
<!-- dev options -->
                      <div class="pb-4" v-if="klnt.show_dev_options">
                        <div class="ml-4 mr-4" style="background-color: orange;  padding: 10px; border-radius: 5px;">
                          <!-- line 1 -->
                          <div style="display: flex; flex-direction: row; gap: 10px; align-items: center; margin-top: 5px;">
                          <!--
                            <v-btn class="primary" x-small @click="loginMe(klnt.klnt_encrid, 1)">
                              MyBooking 1 DEV
                            </v-btn>
                            <v-btn disabled class="primary" x-small @click="loginMe(klnt.klnt_encrid, 2)">
                              MyBooking 1 PRD
                            </v-btn>
                          -->
                            <v-btn class="primary" x-small @click="loginMeDev2(klnt.klnt_encrid, 1)">
                              http://localhost:5173
                            </v-btn>
                            <v-btn class="primary" x-small @click="loginMeDev2(klnt.klnt_encrid, 4)">
                              mydevbooking.villaforyou.com
                            </v-btn>
                            <v-btn class="primary" x-small @click="loginMeDev2(klnt.klnt_encrid, 3)">
                              mytestbooking.villaforyou.com
                            </v-btn>
                          </div>
                          <!-- line 2 -->
                          <div style="display: flex; flex-direction: row; gap: 10px; align-items: center; margin-top: 10px;">
                            <div style="color: white;">Copy (test) payment key to clipboard</div>
                            <v-btn small text icon @click="copyToClipboard()">
                              <v-icon color="white" small>mdi-content-copy</v-icon>
                            </v-btn>
                          </div>
                          <!-- lien 3 -->
                        </div>
                      </div>

<!-- einde dev options -->

                    </v-form>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>


        <!--  Boekingen  -->
        <v-row no-gutters>
          <v-card>

            <v-data-table
              :items="huov"
              :items-per-page="50"
              :footer-props="{
                'items-per-page-options': [50, 100, 200, 300, 500],
              }"
              :headers="huovHeaders"
            >
              <template v-slot:item="props">
                <tr>
                  <td @click="$router.open('/huov/onHuov/' + props.item.huov_encrid)"><a> {{ props.item.huov_code }} </a></td>
                  <td>{{ props.item.huov_dt }}</td>
                  <td @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)">
                    <v-img :src="props.item.photo" width="91px" height="68px"></v-img></td>
                  <td @click="$router.open('/huis/onHuis/' + props.item.huis_encrid)"><a> {{ props.item.huis_code }} </a></td>
                   <td><v-chip :color=props.item.hust_kleur>{{props.item.hust_code}}</v-chip></td>
                  <td>{{ props.item.huov_van_dat }}</td>
                  <td>{{ props.item.huov_tm_dat }}</td>
                  <td>{{ props.item.huov_nachten }}</td>
                  <td>{{ props.item.inpt_naam }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-row>


      </v-container>
    </v-main>
  </v-app>
</template>




<script>
import btn_audit from "@/components/ui/buttons/btn_audit.vue";
import nott from "@/components/nott.vue";
import mergeKlnt from "@/views/klnt/mergeKlnt.vue";
import addKltg from "@/views/klnt/kltg/addKltg.vue";
import addKlpt from "@/views/klnt/klpt/addKlpt.vue";
import klnt_hokl from '@/components/klnt/cards/complaints.vue';
import date_picker from '@/components/ui/date_picker.vue';
import defNavBar from '@/components/ui/navbars/navbar.vue';

import {bus} from "../../main";

 export default {
  components: {
    btn_audit,
    nott,
    mergeKlnt,
    addKltg,
    addKlpt,
    defNavBar,
    klnt_hokl,
    date_picker
  },
  props: ['klnt_encrid'],
  data() {
    return {
      klnt: {
        action_items: []  /* moet pre defined ivm length check */
      },
      huov: [],
      dateOfBirth: '',
      snackbar: false,
      snackbarMessage: '',
      klntCard1Valid: false,
      accesslinksent: false,
      land_nrKeuzes: [],
      taal_nrKeuzes: [],
      kltgHeaders: [
        {text: 'Date / Time', value: 'kltg_dt'},
        {text: 'Description', value: 'kltg_oms'},
        {text: 'Amount', value: 'kltg_bedrag', align: "end"},
        {text: '', value: ''}
       ],
       klptHeaders: [
        {text: 'Date / Time', value: 'klpt_dt'},
        {text: 'Description', value: 'klpt_oms'},
        {text: 'Detail', value: 'klpt_detail'},
        {text: 'Booking', value: 'huov_code'},
        {text: 'Points', value: 'klpt_punten', align: "end"},
        {text: '', value: ''}
       ],
       huovHeaders: [
        { text: "Rental Id", value: "huov_code" },
        { text: "Book date", value: "huov_dt_iso" },
        { sortable: false },
        { text: "Accomodation", value: "huis_code" },
        { text: "Status", value: "hust_code" },
        { text: "Arrival", value: "huov_van_dat_iso" },
        { text: "Departure", value: "huov_tm_dat_iso" },
        { text: "Nights", value: "huov_nachten" },
        { text: "Sales Partner", value: "inpt_naam" }
      ]
    }

  },
  created() {
    bus.$on("addNote", (data) => {
       console.log(data);
       this.klnt.nott_aant += data;
    });
  },
  mounted() {
    this.getKlnt();
  },
  methods: {
    getKlnt(){
      var deze = this;
      this.$axios
        .post("ares/json/ares/klnt/getKlnt.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getKlnt"
          },
          getKlnt: {
            klnt_encrid: this.klnt_encrid
        }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.klnt = res.data.getKlnt;
            console.log('klnt', this.klnt)
            this.dateOfBirth = res.data.getKlnt.klnt_date_of_birth
            this.huov = res.data.getKlnt.huov;
            document.title = 'Guest ' + res.data.getKlnt.klnt_code;
            res.data.getKlnt.land_nrKeuzes.forEach(function(land) {
              deze.land_nrKeuzes.push(land);
            });
            res.data.getKlnt.taal_nrKeuzes.forEach(function(taal) {
              deze.taal_nrKeuzes.push(taal);
            });
          }
        });
    },
    updateData(data){
        this[data.field] = data.value;
    },
    sendUncheckedAccessLink(){
      console.log('sendmail')
      this.$axios
        .post("ares/json/ares/klnt/sendAccessLink.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "sendMail"
          },
          sendMail: {
            encrid: this.klnt_encrid
          }
        }).then(res => {
          console.log(res.data)
          this.accesslinksent = true
        })
    },
    saveKlntCard1() {
      if(this.$refs.klntCard1.validate()) {
      this.$axios
        .post("ares/json/ares/klnt/saveKlntCard1v2.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveKlntCard1"
          },
          saveKlntCard1: {
            klnt_encrid: this.klnt_encrid,
            klnt_naam: this.klnt.klnt_naam,
            klnt_bedrijfsnaam: this.klnt.klnt_bedrijfsnaam,
            klnt_voornaam: this.klnt.klnt_voornaam,
            klnt_adres: this.klnt.klnt_adres,
            klnt_postcode: this.klnt.klnt_postcode,
            klnt_plaats: this.klnt.klnt_plaats,
            land_code: this.klnt.land_code,
            klnt_email: this.klnt.klnt_email,
            klnt_email_extra: this.klnt.klnt_email_extra,
            klnt_tel1_vcs: this.klnt.klnt_tel1_vcs,
            klnt_tel2_vcs: this.klnt.klnt_tel2_vcs,
            klnt_newsletter: this.klnt.klnt_newsletter,
            klnt_paper_mail: this.klnt.klnt_paper_mail,
            taal_code: this.klnt.taal_code,
            klnt_iban: this.klnt.klnt_iban,
            klnt_btw_num: this.klnt.klnt_btw_num,
            klnt_date_of_birth: this.dateOfBirth
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveKlntCard1.text,
              color: res.data.saveKlntCard1.color
            });
          }
        })
      }
    },
    actionClick(action) {
      switch(action) {
        case "mergeKlnt" : this.$refs.mergeKlnt.open(this.klnt_encrid); break;
        case "nott" : this.$refs.nott.open("klnt",this.klnt_encrid,"all"); break;
      }
    },
    changePassword(klnt_encrid) {
       this.$refs.changePassword.open(klnt_encrid);
    },
    // nott(klnt_encrid) {
    //   this.$refs.nott.open("klnt",klnt_encrid,"all");
    // },
    addKltg(klnt_encrid) {
       this.$refs.addKltg.open(klnt_encrid);
    },
    addKlpt(klnt_encrid) {
       this.$refs.addKlpt.open(klnt_encrid);
    },
    loginMeDev2(klnt_encrid, type) {
      // get a new encrypted rowid for the login. The login checks if the encrid is older than 5 mins
      // if it is, it wil not login. If you have this page open longer than 5 mins any login attempt will fail,
      // hence the creation of a new encrid for klnt. The encrid for this page is valid for one hour, that's the error.
      this.$axios
          .post("ares/json/ares/klnt/encryptRowidForLoginV3.p", {
            header: {
              token: this.$session.get("ARES"),
              clientSessionId: this.$session.id(),
              request: "getEncryptedRowidForLogin",
            },
            getEncryptedRowidForLogin: {
              klnt_encrid: klnt_encrid,
            },
          })
          .then((res) => {
            console.log(res.data);
            if (res.data.error) {
              console.log(res.data.error);
            } else {
              switch(type){
                case 1:
                  window.open(`http://localhost:5173/from-ares/${res.data.getEncryptedRowidForLogin.klnt_encrid}`);
                  break;
                case 2:
                  window.open(`https://mybooking.villaforyou.com/from-ares/${res.data.getEncryptedRowidForLogin.klnt_encrid}`);
                  break;
                case 3:
                  window.open(`https://mytestbooking.villaforyou.com/from-ares/${res.data.getEncryptedRowidForLogin.klnt_encrid}`);
                  break;
                case 4:
                  window.open(`https://mydevbooking.villaforyou.com/from-ares/${res.data.getEncryptedRowidForLogin.klnt_encrid}`);
                  break;
              }
            }
          });
    },
    copyToClipboard(){
      // navigator will not work in DEV which is HTTP
      let text = '784f0b7cbd8488d46075267e77e91f28e6ae72e1'
      if (window.isSecureContext && navigator.clipboard) {
        navigator.clipboard.writeText(text);
      } else {
        this.unsecuredCopyToClipboard(text);
      }
    },
    unsecuredCopyToClipboard(text) {

      // create dummy text area
      const textArea = document.createElement("textarea");
      textArea.value = text;

      // avoid scrolling to bottom
      textArea.style.top = "0";
      textArea.style.left = "0";
      textArea.style.position = "fixed";

      // add dummy element and select it
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy'); // deprecated but it still works, for DEV this is acceptable
      } catch (err) {
        console.error('Unable to copy to clipboard', err);
      }
      // kill dummy element
      document.body.removeChild(textArea);
    },
  }
};

</script>

<style scoped>
    .total {
        font-weight: bold;
    }
    .alnright {
        text-align: right;
    }
</style>
